var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.img)?_c('div',{staticClass:"owner-logo-wrapper ml-3"},[_c('img',{staticClass:"test-img",attrs:{"src":_vm.img},on:{"error":_vm.repairLogo}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }